import React, { useState, useRef, useEffect } from "react"
import { Icon } from "@iconify/react"
import { Link } from "react-router-dom"

const NavBar = ({ setNavBarHeight }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const navBarRef = useRef(null)

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen)
  }

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  useEffect(() => {
    if (navBarRef.current) {
      setNavBarHeight(navBarRef.current.offsetHeight)
    }
  }, [setNavBarHeight])

  return (
    <div className="fixed top-0 left-0 w-full z-50 px-4 py-4">
      <div
        ref={navBarRef}
        className="navbar page-frame rounded-[28px] px-4 md:px-6 glass-panel glass-panel-strong"
      >
        <div className="navbar-start">
          <Link to="/" className="flex items-center gap-3 rounded-full px-3 py-2 transition-colors hover:bg-white/5">
            <span className="flex h-11 w-11 items-center justify-center rounded-full border border-primary/20 bg-primary/10 text-primary">
              <Icon icon="gravity-ui:terminal" className="text-xl" />
            </span>
            <div className="leading-tight">
              <div className="text-sm uppercase tracking-[0.28em] text-base-content/50">Portfolio</div>
              <div className="text-lg font-semibold text-base-content">Mahamadou</div>
            </div>
          </Link>
        </div>

        <div className="navbar-center hidden lg:flex">
          <ul className="menu menu-horizontal gap-2 rounded-full border border-white/5 bg-white/[0.02] px-2 py-2">
            <li className="text-base font-semibold">
              <Link className="rounded-full px-5 py-3 hover:bg-primary/10 hover:text-primary" to="/resume">Resume</Link>
            </li>
            <li className="text-base font-semibold relative">
              <button
                onClick={toggleDropdown}
                className="flex items-center gap-2 rounded-full px-5 py-3 hover:bg-primary/10 hover:text-primary"
              >
                <span>Projects</span>
                <Icon
                  icon={isDropdownOpen ? "mdi:chevron-up" : "mdi:chevron-down"}
                />
              </button>
              {isDropdownOpen && (
                <ul className="absolute right-0 top-[calc(100%+1rem)] min-w-60 p-2 space-y-1 rounded-[24px] z-10 glass-panel glass-panel-strong">
                  <li className="text-sm font-medium" onClick={toggleDropdown}>
                    <Link className="rounded-2xl px-4 py-3 hover:bg-primary/10 hover:text-primary" to="/projects/computervision">Computer Vision</Link>
                  </li>
                  <li className="text-sm font-medium" onClick={toggleDropdown}>
                    <Link className="rounded-2xl px-4 py-3 hover:bg-primary/10 hover:text-primary" to="/projects/nlp">NLP</Link>
                  </li>
                  <li className="text-sm font-medium" onClick={toggleDropdown}>
                    <Link className="rounded-2xl px-4 py-3 hover:bg-primary/10 hover:text-primary" to="/projects/dataviz">Data Viz</Link>
                  </li>
                </ul>
              )}
            </li>
          </ul>
        </div>

        <div className="navbar-end lg:hidden">
          <button onClick={toggleMobileMenu} className="btn btn-circle btn-ghost border border-white/10 bg-white/[0.03]">
            <Icon
              icon={isMobileMenuOpen ? "mdi:close" : "mdi:menu"}
              className="text-2xl"
            />
          </button>
        </div>
      </div>
      {isMobileMenuOpen && (
        <>
          <button
            aria-label="Close mobile menu"
            className="fixed inset-0 z-40 bg-black/60"
            onClick={toggleMobileMenu}
          />
          <div className="fixed right-4 top-24 z-50 w-[min(22rem,calc(100%-2rem))] rounded-[28px] p-4 glass-panel glass-panel-strong">
            <ul className="menu gap-2 p-0">
              <li className="text-base font-semibold">
                <Link className="rounded-2xl px-4 py-3 hover:bg-primary/10 hover:text-primary" to="/resume" onClick={toggleMobileMenu}>
                  Resume
                </Link>
              </li>
              <li className="text-base font-semibold">
                <button
                  onClick={toggleDropdown}
                  className="flex items-center justify-between rounded-2xl px-4 py-3 hover:bg-primary/10 hover:text-primary"
                >
                  <span>Projects</span>
                  <Icon
                    icon={isDropdownOpen ? "mdi:chevron-up" : "mdi:chevron-down"}
                  />
                </button>
                {isDropdownOpen && (
                  <ul className="mt-1 space-y-1 pl-2">
                    <li
                      className="text-sm font-medium"
                      onClick={() => {
                        toggleDropdown()
                        toggleMobileMenu()
                      }}
                    >
                      <Link className="rounded-2xl px-4 py-3 hover:bg-primary/10 hover:text-primary" to="/projects/computervision">Computer Vision</Link>
                    </li>
                    <li
                      className="text-sm font-medium"
                      onClick={() => {
                        toggleDropdown()
                        toggleMobileMenu()
                      }}
                    >
                      <Link className="rounded-2xl px-4 py-3 hover:bg-primary/10 hover:text-primary" to="/projects/nlp">NLP</Link>
                    </li>
                    <li
                      className="text-sm font-medium"
                      onClick={() => {
                        toggleDropdown()
                        toggleMobileMenu()
                      }}
                    >
                      <Link className="rounded-2xl px-4 py-3 hover:bg-primary/10 hover:text-primary" to="/projects/dataviz">Data Viz</Link>
                    </li>
                  </ul>
                )}
              </li>
            </ul>
          </div>
        </>
      )}
    </div>
  )
}

export default NavBar
